'use client';

import { detectDevice } from '@/shared/utils/deviceDetection';
import { useEffect, useState } from 'react';

interface DeviceDetection {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLoading: boolean;
}

export function useDeviceDetection(): DeviceDetection {
  const [deviceType, setDeviceType] = useState<DeviceDetection>(() => {
    // 서버 사이드에서는 기본값 반환
    if (typeof window === 'undefined') {
      return {
        isMobile: false,
        isTablet: false,
        isDesktop: false,
        isLoading: true,
      };
    }

    // 클라이언트 사이드에서 즉시 감지
    const device = detectDevice();
    return {
      ...device,
      isLoading: false,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const device = detectDevice();
      setDeviceType({
        ...device,
        isLoading: false,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return deviceType;
}